import type { CategorizedResponse } from "@b2bportal/lodging-api";
import { hotelsApi } from "@overrides/utilities";
import type { HotelLocationSuggestion } from "./types";

export const fetchLocations = async (
  search: string,
  callback: (
    newOptions: HotelLocationSuggestion[],
    fetchedSearch?: string
  ) => void
): Promise<void> => {
  try {
    const res = await hotelsApi.apiV0AutocompleteLodgingPost({
      query: { l: search, LocationQuery: "Label" },
    });

    const options: HotelLocationSuggestion[] =
      res.data.categories?.flatMap((categoryRes: CategorizedResponse) =>
        categoryRes.results.map((s) => ({
          ...s,
          category: categoryRes.category,
          categoryLabel: categoryRes.label,
        }))
      ) ?? [];
    callback(options, search);
  } catch (e) {
    callback([], "");
  }
};
